import { Http, Headers } from '@angular/http';
import { Response } from '@angular/http';
import { Injectable } from '@angular/core';
import { StateService, MODE_NORMAL, MODE_OFFLINE } from './../state.service';
import { AlertService } from './../alert.service';
import { ToastService } from './../toast.service';
import { App, Events, Platform, LoadingController, ToastController } from "ionic-angular";
import { PAGES_CONFIG } from './../../configs/pages.config';
import { EVENTS_CONFIG } from './../../configs/events.config';
import { VERSION_CONFIG } from './../../configs/version.config';
import { ApiAuthStore } from './../store/api.auth.store';
import { Observable } from 'rxjs/Observable';
import { UtilService } from '../../providers/util.service';

export const TIMEOUT_SECONDS = 100000;

//const CONTENT_TYPE_GET = 'text/html,application/xhtml+xml,application/xml;q=0.9,image/webp,image/apng,*/*;q=0.8';
const CONTENT_TYPE_GET = 'application/json';
// const CONTENT_TYPE_POST = 'application/x-www-form-urlencoded';
// const ACCESS_CONTROL_ALLOW_HEADERS = 'Content-Type';
// const ACCESS_CONTROL_ALLOW_ORIGIN = '*';

export interface CdcResponse {
  code: number,
  data: any,
}

@Injectable()
export class ApiBaseService {

  protected headers: Headers;
  protected nav: any;
  protected error: any;

  protected apiName: string;

  // バージョン情報
  appVersion: string;
  appSmallVersion: string;
  isShowVersionUpToast = false;

  constructor(
    protected app: App,
    protected events: Events,
    protected http: Http,
    public plt: Platform,
    protected stateService: StateService,
    protected alertService: AlertService,
    protected toastService: ToastService,
    protected loadingCtrl: LoadingController,
    protected toastController: ToastController,
    protected apiAuthStore: ApiAuthStore,
    public utilService: UtilService,
  ) {
    this.setHeaders();

    let token = ""
    this.apiAuthStore.getToken().then((_token) => {
      token = _token
      if (token) {
        this.setHeaderApiToken(token);
        // イベント登録する
        events.publish(EVENTS_CONFIG.TOKEN, token);
      }
    })

    // APIの実行途中でtokenが更新される場合などがあるため、変更を検知できるようにしておく
    events.subscribe(EVENTS_CONFIG.TOKEN, token => {
      this.setHeaderApiToken(token);
    });

    let uuid = ""
    this.apiAuthStore.getUuid().then((_uuid) => {
      uuid = _uuid
      if (uuid) {
        this.setHeaderUuid(uuid);
        // イベント登録する
        events.publish(EVENTS_CONFIG.UUID, uuid);
      }
    })

    events.subscribe(EVENTS_CONFIG.UUID, uuid => {
      this.setHeaderUuid(uuid);
    });


    this.appVersion = window.localStorage.getItem('STORAGE_KEY.STORAGE_VERSION_INFO');
    this.appSmallVersion = window.localStorage.getItem('STORAGE_KEY.STORAGE_SMALL_VERSION_INFO');

  }


  //**************************
  //* API Request Headerの設定
  //**************************

  setHeaders(): void {
    this.headers = new Headers({
      'Accept': CONTENT_TYPE_GET,
      'Content-type': CONTENT_TYPE_GET,
      'Accept-Language': 'ja,en-US;q=0.9,en;q=0.8',
      'platform': 'ios',
      'app-uuid': '',
      'app-view': '',
      'current-app-version': VERSION_CONFIG.CURRENT_VIESION,
      'current-app-small-version': VERSION_CONFIG.CURRENT_SMALL_VIESION,
    });
  }

  /**
   * トークンをセット更新する処理
   */
  setHeaderApiToken(token) {
    if (this.headers.has('token')) this.headers.delete('token');
    this.headers.append('token', token);
  }

  setHeaderUuid(uuid) {
    if (this.headers.has('app-uuid')) this.headers.delete('app-uuid');
    this.headers.append('app-uuid', uuid);
  }

  setHeaderAppView() {
    if (this.headers.has('app-view')) this.headers.delete('app-view');
    this.headers.append('app-view', window.location.hash);
  }

  getQueryString(params = {}) {
    let queryString = Object.keys(params).map(key => `${key}=${params[key]}`).join('&');
    return queryString;
  }

  /**
   * POST処理
   * @param params
   * @return Promise
   */
  doPost(params, message = null) {
    // - API実行時に画面情報を都度送りたい TODO: 後で良い方法考える
    this.setHeaderAppView();

    return this.http.post(params['url'], params['body'], {headers: params['headers']})
    .map((response) => {
      this.handlerSuccess(response, message);
      return response.json()
    })
    .catch(err => this.handleError(err));
  }

  /**
   * PUT処理
   * @param params
   * @return Promise
   */
  doPut(params) {

    // - API実行時に画面情報を都度送りたい TODO: 後で良い方法考える
    this.setHeaderAppView();

    return this.http.put(params['url'], params['body'], {headers: params['headers']})
    .map((response) => {
      this.handlerSuccess(response);
      return response.json()
    })
    .catch(err => this.handleError(err));
  }


  /**
   * Get処理
   * @param params
   * @return Promise
   */
  doGet(params) {
    // - API実行時に画面情報を都度送りたい TODO: 後で良い方法考える
    this.setHeaderAppView();

    if (!params['url']) return;
    return this.http.get(params['url'], {headers: params['headers']})
    .map((response) => {
      this.handlerSuccess(response);
      return response.json()
    })
    .catch(err =>this.handleError(err))
  }

  /**
   * Delete処理
   * @param params
   * @return Promise
   */
  doDelete(params) {
    // - API実行時に画面情報を都度送りたい TODO: 後で良い方法考える
    this.setHeaderAppView();

    return this.http.delete(params['url'], {headers: params['headers']})
    .map((response) => {
      this.handlerSuccess(response);
      return response.json()
    })
    .catch(err =>this.handleError(err))
  }

  handlerSuccess(response: Response, message = null) {
    // 状態を成功状態にする
    this.stateService.state(MODE_NORMAL)
    this.codePushVersionUpCheck(response.json()['version']);
    // バージョンアップチェック
    this.versionUpCheck(response);
    // toast表示
    this.showToast(response.json()['toast']);
    // modal表示
    if (message) {
      this.showModal(message);
    } else {
      this.showModal(response.json()['modal']);
    }
  }

  handleError(error: any) {

    console.log('ネットワーク不備のときのエラーを検知');
    console.log(error);
    console.log(this)

    this.error = error;
    if (this.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', this.error.message);
    } else {
      // BODYが存在しているか？
      // {_body: "{"message":"ライセンスキーの認証が出来ませんでした"}"}

      let responseBody = {};
      if (this.error && this.error._body) {
        try {
          responseBody = this.error.json();
        } catch(e) {
          console.log(e);
          responseBody = {};
        }
      };
      console.log("BODY情報の取得");
      console.log(responseBody);
      // エラーのときでもレスポンスBODYにモーダル表示の指定があれば表示されるようにする
      this.showToast(responseBody['toast']);
      this.showModal(responseBody['modal']);


      console.error(
        `Backend returned code ${this.error.status}, ` +
        `body was: ${this.error._body}`);


      this.nav = this.app.getActiveNavs();

      console.log('エラー内容を確認する');
      console.log(error);
      // 認証関連でエラーがあった場合
      if (error.status === 401) {
        this.status401(responseBody);
        return Observable.throw(error)
      }

      Promise.all([
        this.apiAuthStore.getLicenseKey(),
        this.apiAuthStore.getToken(),
      ]).then((response) => {

        console.log(response);

        let _licenseKey = response[0]
        //let _token = response[1]

        console.log("licenseKey::")
        console.log(_licenseKey)

        // TODO: オフラインモード、ゲストモードは次回アップデートに回すので下記全般コメントアウトする
        // - そしてこのnoLicenseKeyというのを問答無用に実行することにしてみる
        this.noLicenseKey(responseBody, error)

      })
      return Observable.throw(error)
    }
  };

  codePushVersionUpCheck(versionInfo): void {
    // バージョンアップのチェック
    if (!versionInfo) {
      return;
    }
    // ローカルに保存しているバージョン情報
    const currentCommitHash = window.localStorage.getItem('STORAGE_KEY.STORAGE_SMALL_VERSION_INFO');
    const { forceUpdate, version, commitHash } = versionInfo;

    // データがなくても念の為更新があるかのチェックを行っておく(インストール直後は、キー情報が無いため)
    if (!currentCommitHash) {
      this.saveVersion(version, commitHash);
      return;
    }

    // 通常アップデートで既に表示した場合、何もせず終了
    if (currentCommitHash === commitHash) {
      return;
    }
    // 既に起動中の場合、何もせず終了
    if (this.isShowVersionUpToast) {
      return;
    }
    this.isShowVersionUpToast = true;

    // Ionic 3 だとボタンを２つだせないので、全て強制アップデートとしてアップデートのチェックを行うようにしておく
    // 強制アップデートの場合は、数秒後に強制的に自動読み込みさせる動きとする
    if (true || forceUpdate) {
      this.saveVersion(version, commitHash);


      // Webの場合は、強制リロードの実施
      setTimeout(async () => {
        const loading = await this.loadingCtrl.create({ content: 'アプリの更新中...' });
        loading.present();
        location.reload();
      }, 10 * 1000);

      const message = 'アプリが更新されました。10秒後に読み込みを開始します。';
      this.presentToast({
        message,
        position: 'bottom',
        buttons: [],
      });
    }
    return;
  }
  private saveVersion(version: string, commitHash: string) {
    this.appVersion = version;
    this.appSmallVersion = commitHash;
    window.localStorage.setItem('STORAGE_KEY.STORAGE_VERSION_INFO', version);
    window.localStorage.setItem('STORAGE_KEY.STORAGE_SMALL_VERSION_INFO', commitHash);
  }

  private presentToast(options: any) {
    const toast = this.toastController.create(options);
    toast.present();
  }

  /**
   * バージョンアップチェック
   * @param res
   * @return void
   */
  versionUpCheck(res): void {

    // アップデート情報をヘッダーから取得する
    let versionUpdateCode = res.headers.get('update-code');
    let versionUpMsg = res.headers.get('update-msg');
    let version = res.headers.get('next-app-version');

    // TODO: 暫定対応::::::レスポンスヘッダーがなぜか取れないので、bodyに含めることにする！！！
    let versionUp = res.json()['versionUp'];
    if (!versionUp) return ;
    versionUpdateCode = versionUp['update-code'];
    versionUpMsg = versionUp['update-msg'];
    version = versionUp['next-app-version'];
    // ::::::: :::::::: ::::::: ::::::: :::::::: :::::::


    // バージョンアップDebug用
    // versionUpdateCode = "2"
    // versionUpMsg = 'アプリストアから新バージョンのアプリをダウンロードしてください。'

    if (versionUpdateCode) {
      console.log('バージョンアップの指示有り')
      console.log(versionUpdateCode);

      // TODO: cookieが使えないので、localStorageに一旦置き換えます
      // if (this.cookieService.get(COOKIES_CONFIG.COOKIES_VERSION_UP) === version) {
      //   return;
      // }
      if (VERSION_CONFIG.CURRENT_VIESION === version) {
        return ;
      }

      // let handler = () => {};
      let handler = () => {
        this.events.publish(EVENTS_CONFIG.VERSION_UP, versionUpdateCode);
      }
      // TODO: 暫定対応
      if (versionUpdateCode !== '0') {
        this.alertService.basic('新バージョンのお知らせ', versionUpMsg, handler);
      }
      return;
    }


  }

  /**
   * メンテナンス時の処理
   * @return void
   */
  maintenance(responseBody): void {


    let maintenanceCode = this.error.headers.get('maintenance-code');
    let maintenanceMsg  = this.error.headers.get('maintenance-msg');

    if (!maintenanceCode) {
      let body = {};
      try {
        body = JSON.parse(this.error._body);
      } catch(e) {
        console.log(e);
      }
      //
      console.log(body);
      if (body['maintenance']) {
        maintenanceCode = body['maintenance']['maintenanceCode'];
        maintenanceMsg  = body['maintenance']['maintenanceMsg'];
      } else {
        maintenanceCode = "2";
        maintenanceMsg = "ご迷惑をおかけしており、<br>申し訳ございません。";
      }
    }

    let handler = () => {
      this.events.publish(EVENTS_CONFIG.MAINTENANCE, maintenanceCode);
    }
    console.log(maintenanceCode);
    // メンテナンスモード 1 以外はモーダルを出す
    if (maintenanceCode !== "1") {
      this.alertService.basic('メンテナンス実施中', maintenanceMsg, handler);
      return;
    }
    // バイタル登録
    if (this.error.url.match(/vital/)) {
      this.alertService.basic('メンテナンス実施中', maintenanceMsg, handler);
      return;
    }
  }

  /**
   * InternalServerError 500
   * @return void
   */
  status500(responseBody): void {
    // bodyに message があればその内容を表示。なければ、デフォルトの値を表示する
    if (responseBody.message) {
      this.alertService.basic(
        'エラー',
        responseBody.message,
        () => {
        });
    }
  }
  /**
   * BadGateway 502
   *
   * 502が出る時サーバがダウンしている時
   * @return void
   */
  status502(responseBody): void {
    // bodyに message があればその内容を表示。なければ、デフォルトの値を表示する
    let message = 'サーバがダウンしている<br>可能性があります。<br>ご迷惑をおかけしており、<br>申し訳ございません。';
    if (responseBody.message) {
      message = responseBody.message;
    }
    this.alertService.basic(
      '通信エラー',
      message,
      () => {
      });
  }

  status401(responseBody): void {
    // bodyに message があればその内容を表示。なければ、デフォルトの値を表示する
    let message = '再度ログインをお試しください';

    // 中身見て、強制なのか、何なのかエラーチェック -> 飛ばす

    if (responseBody.message) {
      message = responseBody.message;
    }
    this.alertService.basic(
      '認証エラー',
      message,
      () => {
        this.events.publish(EVENTS_CONFIG.SET_ROOT, PAGES_CONFIG.LOGIN)
      });
  }

  /**
   * [ネットワークエラー]
   *
   */
  status0(responseBody): void {
    // this.stateService.state(MODE_OFFLINE);
    this.alertService.basic(
      '通信エラー',
      'インターネット回線が不安定です。<br>しばらくしてから、<br>もう一度お試しください。',
      () => {
      }
    );
  }

  noLicenseKey(responseBody, error): void {
    this.stateService.state(MODE_NORMAL);
    console.log(error);

    if (error.status === 0) {
      this.status0(responseBody);
    }
    // - サーバ側でエラーがあった場合
    if (error.status === 500) {
      this.status500(responseBody);
    }
    // - サーバ側でエラーがあった場合
    if (error.status === 502) {
      this.status502(responseBody);
    }
    // - status:503 => メンテナンスモード
    if (error.status === 503) {
      this.maintenance(responseBody);
    }
  }

  offline(responseBody, error) {

    this.stateService.state(MODE_OFFLINE)

    // ゲストモードでのログインを実施
    this.events.publish(EVENTS_CONFIG.LOGIN_OFFLINE);

     // - status:0 => ネットワーク通信エラー(オフラインの状況など)
    //  if (error.status === 0) {
    //   this.status0(responseBody);
    // }
    // // - サーバ側でエラーがあった場合
    // if (error.status === 500) {
    //   this.status500(responseBody);
    // }
    // // - status:503 => メンテナンスモード
    // if (error.status === 503) {
    //   this.maintenance(responseBody);
    // }
    // // 認証関連でエラーがあった場合
    // if (error.status === 401) {
    //   this.status401(responseBody);
    // }
  }


  showToast(res) {
    // console.log("共通トースト表示判定");
    // console.log(res);
    if (!res) return;
    this.toastService.basic(res.message, res.duration, res.position);
  }

  showModal(res) {
    // console.log("共通モーダル表示判定");
    // console.log(res);
    if (!res) return;
    this.alertService.basic(res.title, res.subtitle, ()=>{});
  }



  /**
   * ビューワーは、現状別のAPIのため、そちらから情報を取得できるようにしておく
   */
  doGetViewerApi(params) {
    // - API実行時に画面情報を都度送りたい TODO: 後で良い方法考える
    this.setHeaderAppView();

    if (!params['url']) return;
    return this.http.get(params['url'], { headers: params['headers'] })
      .map((response) => {
        this.handlerSuccess(response);
        return response.json()
      })
      .catch(err => this.handleError(err))
  }

}



// WEBPACK FOOTER //
// ./src/providers/api-call-providers/api-base.service.ts